import { ContentArea, HeroInsightSectionPage } from "/App.Components";
import { ContentAreaType } from "/Models/Generated/ContentAreaType";
import { InsightSectionPageProps } from "/Models/Generated/InsightSectionPageProps";
import ContentSearch from "../../Shared/Contentsearch/ContentSearch";
import "./InsightSectionPage.scss";

const InsightSectionPage = ({
  pageHeader,
  contentArea,
  hiddenH1,
  insightSearchBlock,
}: InsightSectionPageProps) => {
  return (
    <div className="insight-section-page-norad">
      {hiddenH1 && (
        <h1 className="thematic-page-norad__hidden-h1">{hiddenH1}</h1>
      )}

      <HeroInsightSectionPage {...pageHeader} useH2InHeader={!!hiddenH1} />
      <div className="insight-section-page-norad__main-content">
        <ContentArea
          {...contentArea}
          contentAreaType={ContentAreaType.HalfWidth}
        />
      </div>
      {insightSearchBlock && (
        <div>
          <ContentSearch
            insightSearchBlock={insightSearchBlock}
          />
        </div>
      )}
    </div>
  );
};
export default InsightSectionPage;
